"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieWatcher = void 0;
var _deepObjectDiff = require("deep-object-diff");
var _es = _interopRequireDefault(require("fast-deep-equal/es6"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function noop() {};
var DEFAULT_POLLING_TIME = 1000;
var CookieWatcher = /*#__PURE__*/function () {
  function CookieWatcher(options) {
    this._cookiesChangeListeners = [];
    this._cookieChangeListeners = {};
    this._previousCookies = {};
    var _ref = options || {},
      _ref$pollingTime = _ref.pollingTime,
      pollingTime = _ref$pollingTime === void 0 ? DEFAULT_POLLING_TIME : _ref$pollingTime;
    this._pollingTime = pollingTime;
    this._createWatcher();
  }
  var _proto = CookieWatcher.prototype;
  _proto._createWatcher = function _createWatcher() {
    var isBrowser = typeof window !== "undefined";
    if (!isBrowser) return null;
    var isCookieStoreApiAvailable = "cookieStore" in window || "CookieStore" in window;
    if (isCookieStoreApiAvailable) {
      this._watcherDestroy = this._createApiWatcher();
    } else {
      this._watcherDestroy = this._createIntervalWatcher();
    }
  };
  _proto._createApiWatcher = function _createApiWatcher() {
    var _this = this;
    var cookieStoreApi = window.cookieStore || window.CookieStore;
    var onChange = function onChange(event) {
      _this._emitChange(event);
    };
    if ("addEventListener" in cookieStoreApi) {
      cookieStoreApi.addEventListener("change", onChange);
      return function () {
        cookieStoreApi.removeEventListener("change", onChange);
      };
    }
    if ("onchange" in cookieStoreApi) {
      cookieStoreApi.onchange = onChange;
      return function () {
        cookieStoreApi.onchange = noop;
      };
    }
    return noop;
  };
  _proto._createIntervalWatcher = function _createIntervalWatcher() {
    var _this2 = this;
    this._previousCookies = _jsCookie.default.get();
    var createCookiesChangeEvent = function createCookiesChangeEvent(diff) {
      var entries = Object.entries(diff);
      var changed = entries.map(function (_ref2) {
        var name = _ref2[0],
          value = _ref2[1];
        return {
          name,
          value
        };
      });
      return {
        changed
      };
    };
    var intervalId = setInterval(function () {
      var currentCookies = _jsCookie.default.get();
      if (!(0, _es.default)(_this2._previousCookies, currentCookies)) {
        var diff = (0, _deepObjectDiff.diff)(_this2._previousCookies, currentCookies);
        var _event = createCookiesChangeEvent(diff);
        _this2._emitChange(_event);
      }
      _this2._previousCookies = currentCookies;
    }, this._pollingTime);
    return function () {
      clearInterval(intervalId);
    };
  };
  _proto._callCookiesEventListeners = function _callCookiesEventListeners(event) {
    this._cookiesChangeListeners.forEach(function (listener) {
      listener(event);
    });
  };
  _proto._callCookieEventListeners = function _callCookieEventListeners(event) {
    var _this3 = this;
    var changed = event.changed;
    changed.forEach(function (cookie) {
      var listeners = _this3._cookieChangeListeners[cookie.name];
      if (listeners && listeners.length > 0) {
        listeners.forEach(function (listener) {
          listener(cookie);
        });
      }
    });
  };
  _proto._emitChange = function _emitChange(event) {
    this._callCookiesEventListeners(event);
    this._callCookieEventListeners(event);
  };
  // eslint-disable-next-line no-dupe-class-members
  _proto.addChangeListener = function addChangeListener(cookieNameOrCallback, callback) {
    var hasCookieName = typeof cookieNameOrCallback === "string";
    if (hasCookieName) {
      var _cookieName = cookieNameOrCallback;
      var _cb = callback;
      if (typeof _cb === "undefined") {
        return;
      }
      var existCookieCallbacks = this._cookieChangeListeners[_cookieName] || [];
      this._cookieChangeListeners[_cookieName] = [].concat(existCookieCallbacks, [_cb]);
      return;
    }
    var cb = cookieNameOrCallback;
    this._cookiesChangeListeners.push(cb);
  };
  _proto.removeChangeListener = function removeChangeListener(cookieNameOrCallback, callback) {
    var hasCookieName = typeof cookieNameOrCallback === "string";
    if (hasCookieName) {
      var _cookieName2 = cookieNameOrCallback;
      var _cb2 = callback;
      var existCookieCallbacks = this._cookieChangeListeners[_cookieName2] || [];
      this._cookieChangeListeners[_cookieName2] = existCookieCallbacks.filter(function (item) {
        return item !== _cb2;
      });
      return;
    }
    var cb = cookieNameOrCallback;
    this._cookiesChangeListeners = this._cookiesChangeListeners.filter(function (item) {
      return item !== cb;
    });
  };
  _proto.destroy = function destroy() {
    if (this._watcherDestroy) this._watcherDestroy();
    this._cookiesChangeListeners = [];
    this._cookieChangeListeners = {};
  };
  return CookieWatcher;
}();
exports.CookieWatcher = CookieWatcher;